import { render, staticRenderFns } from "./SinamedSync.vue?vue&type=template&id=ea972c48"
import script from "./SinamedSync.vue?vue&type=script&lang=js"
export * from "./SinamedSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports